import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";
import VariableValueForm from "../types/VariableValueForm";

export const CustomerDaysWithoutConversionForm = ({
  visible,
  onClose,
  node,
  onSave,
  onRemove,
}) => {
  const input_configs = {
    type: "currency",
    prefix: "",
    suffix: " dias",
    precision: 0,
    min: 0,
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.CustomerDaysWithoutConversion}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <VariableValueForm
        node={node}
        input_configs={input_configs}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
        disableTimeRange
      />
    </Drawer>
  );
};
